module.exports = __webpack_public_path__ + "img/cuad-1_scaled.91341f66.jpg";